var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _handleProductSelect;
import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { StandardEvents, ProductSelectEvent } from "@shopify/events";
class ProductSkuComponent extends Component {
  constructor() {
    super(...arguments);
    this.selectionGeneration = 0;
    this.selectionDetached = false;
    this.selectionTarget = null;
    __publicField(this, "requiredRefs", ["skuContainer", "sku"]);
    __privateAdd(this, _handleProductSelect, (event) => {
      var _a;
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      if (((_a = event.product) == null ? void 0 : _a.id) && this.dataset.productId && String(event.product.id) !== String(this.dataset.productId)) return;
      const generation = ++this.selectionGeneration;
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        if (!detail) return;
        const { newProduct, resource } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        }
        if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }
        if (resource) {
          const variantSku = resource.sku || "";
          if (variantSku) {
            this.style.display = "block";
            this.refs.sku.textContent = variantSku;
          } else {
            this.style.display = "none";
            this.refs.sku.textContent = "";
          }
        } else {
          this.style.display = "none";
          this.refs.sku.textContent = "";
        }
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[product-sku] Event promise rejected:", error);
      });
    });
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    this.selectionDetached = false;
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    (_a = this.selectionTarget) == null ? void 0 : _a.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.selectionTarget = target;
    target.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    (_a = this.selectionTarget) == null ? void 0 : _a.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.selectionTarget = null;
  }
}
_handleProductSelect = /* @__PURE__ */ new WeakMap();
if (!customElements.get("product-sku-component")) {
  customElements.define("product-sku-component", ProductSkuComponent);
}
